import { render } from "./homeTrendsCentre.vue?vue&type=template&id=b6271106&scoped=true"
import script from "./homeTrendsCentre.vue?vue&type=script&lang=js"
export * from "./homeTrendsCentre.vue?vue&type=script&lang=js"

import "./homeTrendsCentre.vue?vue&type=style&index=0&id=b6271106&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\LyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b6271106"]])

export default __exports__